var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5834 19.7229H6.41671C3.66671 19.7229 1.83337 18.3479 1.83337 15.1395V8.72286C1.83337 5.51453 3.66671 4.13953 6.41671 4.13953H15.5834C18.3334 4.13953 20.1667 5.51453 20.1667 8.72286V15.1395C20.1667 18.3479 18.3334 19.7229 15.5834 19.7229Z",
    fill: "#5B6B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.7286C10.23 12.7286 9.45084 12.4903 8.855 12.0045L5.98583 9.71279C5.6925 9.47446 5.6375 9.04362 5.87584 8.75029C6.11417 8.45696 6.54501 8.40196 6.83834 8.64029L9.7075 10.932C10.4042 11.4911 11.5867 11.4911 12.2833 10.932L15.1525 8.64029C15.4458 8.40196 15.8858 8.44779 16.115 8.75029C16.3533 9.04362 16.3075 9.48363 16.005 9.71279L13.1358 12.0045C12.5492 12.4903 11.77 12.7286 11 12.7286Z",
    fill: "#5B6B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.db1526e1a5ef24014341bd46b414c271.svg";
export { ForwardRef as ReactComponent };